import { useRef } from "react";

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition;

export const useVoiceInput = (onResult) => {
  const recognitionRef = useRef(null);

  const startListening = () => {
    if (!SpeechRecognition) {
      alert("Voice recognition not supported in this browser");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-IN"; // Hindi + English mix
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = (event) => {
      const speechText = event.results[0][0].transcript;
      onResult(speechText);
    };

    recognition.onerror = (err) => {
      console.error(err);
      alert("Voice recognition failed. Try again!");
    };

    recognition.start();
    recognitionRef.current = recognition;
  };

  return { startListening };
};
